import typeToReducer from 'type-to-reducer';
import {
  CHANGE_DATE_BY_TYPE,
  CHANGE_ACTIVE_TAB,
  FETCH_BONUS_LIST,
  FETCH_CREDIT_BONUS_LIST,
  SET_CURRENT_PAGE,
  FETCH_REGISTRATION_OFFERS,
} from 'accountBonusActions.js';

let initialState = {
  isPending: true,
  error: null,
  startDate: new Date(),
  endDate: new Date(),
  activeTab: 'active',
  bonus: {
    active: {
      currentPage: 0,
      data: [],
      isNextPageAvailable: false,
    },
    history: {
      currentPage: 0,
      data: [],
      isNextPageAvailable: false,
    },
    queue: {
      currentPage: 0,
      data: [],
      isNextPageAvailable: false,
    },
  },
  limit: 5,
  registrationOffers: [],
};

export default typeToReducer(
  {
    [CHANGE_DATE_BY_TYPE]: (state, { payload: { dateType, date } }) => {
      return { ...state, [dateType]: date };
    },
    [CHANGE_ACTIVE_TAB]: (state, { payload: { activeTab } }) => {
      return { ...state, activeTab };
    },
    [SET_CURRENT_PAGE]: (state, { payload: { currentPage, activeTab } }) => {
      return {
        ...state,
        bonus: {
          ...state.bonus,
          ...(activeTab
            ? {
                [activeTab]: { ...state.bonus[activeTab], currentPage },
              }
            : {
                [state.activeTab]: { ...state.bonus[state.activeTab], currentPage },
              }),
        },
      };
    },
    [FETCH_BONUS_LIST]: {
      PENDING: (state, action) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (state, { payload: { data, isNextPageAvailable } }) => {
        return {
          ...state,
          isPending: false,
          bonus: {
            ...state.bonus,
            [state.activeTab]: { ...state.bonus[state.activeTab], data, isNextPageAvailable },
          },
        };
      },
      FULFILLED: (state, action) => {
        return { ...state, isPending: false };
      },
    },
    [FETCH_CREDIT_BONUS_LIST]: {
      PENDING: (state, action) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (state, { payload: { data, isNextPageAvailable } }) => {
        return {
          ...state,
          isPending: false,
          bonus: {
            ...state.bonus,
            [state.activeTab]: { ...state.bonus[state.activeTab], data, isNextPageAvailable },
          },
        };
      },
      FULFILLED: (state, action) => {
        return { ...state, isPending: false };
      },
    },
    [FETCH_REGISTRATION_OFFERS]: {
      PENDING: (state) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (state, { payload: { data } }) => {
        return { ...state, registrationOffers: data };
      },
    },
  },
  initialState
);
